'use client'

import PropTypes from 'prop-types'
import MUIStack from '@mui/material/Stack'
import MUIButton from '@mui/material/Button'
import { ArrowRightIcon } from '@repo/ui/ArrowRightIcon'
import { useTheme } from '@mui/material/styles'

export const WizardFooter = ({
  wideMode = false,
  handleClickContinue,
  handleClickBack,
  continueButtonText = 'Continue',
  backButtonVisible = true,
  continueButtonIsFormSubmitButton = false,
  continueButtonDisabled = false
}) => {
  const theme = useTheme()

  return (
    <MUIStack
      data-testid="WizardFooter"
      direction="row"
      alignItems="center"
      gap={2}
      justifyContent="space-between"
      sx={{
        width: wideMode ? 'calc(100% - 300px)' : 'calc(100% - 270px)',
        height: '104px',
        backgroundColor: 'background.mid',
        position: 'absolute',
        bottom: 0,
        left: wideMode ? '300px' : '270px',
        padding: '0 36px 0 16px',
        zIndex: 10
      }}
    >
      <MUIButton
        variant="contained"
        startIcon={
          <ArrowRightIcon
            sx={{
              color: theme?.palette?.text?.secondary || 'black',
              opacity: backButtonVisible ? 1 : 0.5,
              fontSize: '14px',
              height: '14px',
              width: '14px',
              transform: 'rotate(180deg)'
            }}
          />
        }
        sx={{
          padding: '7px 16px 6px 16px',
          height: '36px',
          textTransform: 'none',
          color: 'text.secondary',
          width: '110px',
          backgroundColor: 'transparent',
          '&:hover,&:disabled': {
            backgroundColor: 'transparent'
          },
          '.MuiButton-startIcon': {
            marginLeft: '0',
            width: '14px',
            marginRight: '8px'
          }
        }}
        onClick={handleClickBack}
        tabIndex={0}
        disabled={!backButtonVisible}
      >
        Back
      </MUIButton>

      <MUIButton
        endIcon={<ArrowRightIcon sx={{ color: 'white', fontSize: '14px', height: '14px', width: '14px' }} />}
        variant="contained"
        sx={{
          backgroundColor: 'success.light',
          borderRadius: 20,
          padding: '6px 16px 6px 16px',
          height: '36px',
          width: 'auto',
          '&[disabled]': {
            color: 'white'
          },
          '&:hover': {
            backgroundColor: 'success.lightHover'
          },
          '.MuiButton-endIcon': {
            marginRight: '0',
            width: '14px',
            marginLeft: '8px'
          }
        }}
        onClick={handleClickContinue}
        data-testid="ContinueButton"
        type={continueButtonIsFormSubmitButton ? 'submit' : 'button'}
        disabled={continueButtonDisabled}
        tabIndex={-1}
      >
        {continueButtonText}
      </MUIButton>
    </MUIStack>
  )
}

WizardFooter.propTypes = {
  wideMode: PropTypes.bool,
  handleClickContinue: PropTypes.func,
  handleClickBack: PropTypes.func,
  continueButtonText: PropTypes.string,
  backButtonVisible: PropTypes.bool,
  continueButtonIsFormSubmitButton: PropTypes.bool,
  continueButtonDisabled: PropTypes.bool
}
